<section class="privacy-page animate-fade-in-up" aria-label="Privacy Directive">
    <div class="privacy-page__container">
        <div class="privacy-page__title">Privacy Directive</div>
        <div class="privacy-page__revision">Revision: {{ revisionDate }}</div>

        <div class="privacy-page__content">
            <article class="privacy-page__block">
                <div class="privacy-page__block-title">1. AI Telemetry & Data Collection</div>
                <div class="privacy-page__block-copy">
                    We systematically collect metadata provided directly through our secure interfaces. Reve Cloud
                    operates under strict Zero-Trust principles; no enterprise telemetry submitted via these contact
                    forms is ever used to train public or foundational language models.
                </div>
            </article>

            <article class="privacy-page__block">
                <div class="privacy-page__block-title">2. Utilization Vectors</div>
                <div class="privacy-page__block-copy">
                    Collected data is strictly utilized to architect tailored Applied AI proposals and maintain secure
                    communication channels regarding your specific cognitive infrastructure requirements.
                </div>
            </article>
        </div>
    </div>
</section>